import PaginatedGroup from "@/components/ui/PaginatedGroup";
import GroupCard from "@/components/ui/PaginatedGroup/GroupCard";
import { useUser } from "@/context/user-context";

import { useGetReportsByPromptId } from "@/queries/evals/useGetReportsByPromptId";
import { Report } from "@/types/evaluate";
import { UseQueryResult } from "@tanstack/react-query";

interface PipelineGroupProps {
  promptId: number;
}

const PipelineGroup = ({ promptId, ...props }: PipelineGroupProps) => {
  const workspaceId = useUser().activeWorkspaceId!;

  const Query = (
    page: number,
    perPage: number,
  ): UseQueryResult<
    { reports: Report[]; total: number; pages: number },
    unknown
  > | null => {
    const result = useGetReportsByPromptId({
      workspace_id: workspaceId!,
      prompt_id: promptId,
      page,
      per_page: perPage,
      is_blueprint: true,
    });

    if (!result.data)
      return result as unknown as UseQueryResult<
        { reports: Report[]; total: number; pages: number },
        unknown
      > | null;

    return {
      ...result,
      data: {
        reports: result.data.reports,
        total: result.data.total,
        pages: result.data.pages,
      },
    } as UseQueryResult<
      { reports: Report[]; total: number; pages: number },
      unknown
    >;
  };

  return (
    <PaginatedGroup<Report, { reports: Report[]; total: number; pages: number }>
      {...props}
      title="Evaluations"
      extractData={(data) => {
        return {
          data: data.reports,
          totalPages: data.pages,
          totalItems: data.total,
        };
      }}
      query={Query}
      renderItem={(item) => (
        <GroupCard
          title={item.name}
          description={""}
          to={`/workspace/${workspaceId}/evaluate/blueprints/${item.id}`}
        />
      )}
      getItemKey={(item) => item.id}
    />
  );
};

export default PipelineGroup;
